<template>
  <div class="aha-textarea-wrapper">
    <!-- Why 2 text-area? Using @keydown.enter="$event.preventDefault()" doesn't work since Vue.js
      does not support inline expressions with modifiers preventEnterNewLine -->
    <div class="aha-textarea__button-at-start" v-if="hasButtonAtStart" @click="$emit('buttonAtStartClick')">
      <slot name="buttonAtStart" />
    </div>
    <textarea
      v-if="preventEnterNewLine"
      class="aha-textarea"
      :name="name"
      :placeholder="placeholder"
      :class="[{error}, classes]"
      :required="required"
      :maxlength="maxLength"
      :value="value"
      :disabled="isDisabled"
      :rows="rows"
      :cols="cols"
      :readonly="readonly"
      :autofocus="autofocus"
      @input="$emit('input', $event.target.value); $emit('autoExpand', $event.target)"
      @focus="$emit('focus')"
      @blur="$emit('blur')"
      @keydown.enter.exact.prevent="$emit('keyupEnter')"
    />
    <textarea
      v-else
      class="aha-textarea"
      :name="name"
      :placeholder="placeholder"
      :class="[{error}, classes]"
      :required="required"
      :maxlength="maxLength"
      :value="value"
      :disabled="isDisabled"
      :rows="rows"
      :cols="cols"
      :readonly="readonly"
      :autofocus="autofocus"
      @input="$emit('input', $event.target.value)"
      @focus="$emit('focus')"
      @blur="$emit('blur')"
    />
    <div class="aha-textarea-limit" v-if="maxLength">
      {{ maxLength - (value ? value.length : 0) }}
    </div>
    <div class="aha-textarea-button" v-if="hasButtonOnEnd" @click.stop="$emit('buttonClick')">
      <slot name="button" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    maxLength: {
      default: null,
      type: Number,
    },
    classes: {
      type: String,
      default: '',
    },
    isDisabled: {
      default: false,
      type: Boolean,
    },
    error: {
      type: Boolean,
      default: false,
    },
    hasButtonOnEnd: {
      type: Boolean,
      default: false,
    },
    hasButtonAtStart: {
      type: Boolean,
      default: false,
    },
    preventEnterNewLine: {
      type: Boolean,
      default: false,
    },
    cols: {
      type: Number,
      default: 50,
    },
    rows: {
      type: Number,
      default: 4,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
  .aha-textarea-wrapper {
    @apply relative;
  }
  .aha-textarea {
    @apply w-full my-2 p-3 block;
    @apply border border-secondary-20 border-solid rounded-md;
    @apply hover:border-primary-80 focus:border-primary-80 focus:outline-none;
    @apply focus:bg-primary-20 hover:bg-primary-20;

    &.error, &:hover.error {
      border: 1px solid #ff5050;
      border-color: #ff5050;
    }
  }
  .aha-textarea-limit {
    @apply absolute bottom-2 right-2 text-secondary-40;
  }
  .aha-textarea-button {
    @apply cursor-pointer;
  }
</style>
